import globals from './_globals';

const elementsToShow = document.querySelectorAll( '.animate-on-scroll' );
let scroll = window.requestAnimationFrame || function( callback ){ window.setTimeout( callback, 1000/60 ); };

// forEach polyfill
if ( window.NodeList && !NodeList.prototype.forEach ) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 *
 *
 *
 */
const init = function() {
	loop();
};

/**
 *
 *
 *
 */
const loop = function() {

	updateBodyClasses();

	elementsToShow.forEach( ( element ) => {

		const baseClass      = 'animated';
		// const resetOnExit 	 = element.getAttribute( 'data-reset-animate' );
		let desktopAnimation = element.getAttribute( 'data-desktop-animate' );
		let mobileAnimation  = element.getAttribute( 'data-mobile-animate' );

		if ( !mobileAnimation ) {
			mobileAnimation = desktopAnimation;
		}

		if ( !mobileAnimation && !desktopAnimation ) {
			mobileAnimation = 'fadeIn';
			desktopAnimation = 'fadeIn';
		}

		// when element enters viewport
		if ( isElementInViewport( element ) ) {

			if ( element.classList.contains( baseClass ) ) {
				return;
			}

			if ( getWindowWidth() >= globals.breakpoint ) {
				element.classList.add( baseClass );
				element.classList.add( desktopAnimation );
			} else {
				element.classList.add( baseClass );
				element.classList.add( mobileAnimation );
			}

		// when element leaves viewport
		} else {

			// if ( resetOnExit === 'true' ) {
			// 	element.classList.remove( baseClass );
			// 	element.classList.remove( desktopAnimation );
			// 	element.classList.remove( mobileAnimation );
			// }

		}

	});

	scroll( loop );

};

/**
 *
 *
 *
 */
const updateBodyClasses = function() {

	var supportPageOffset = window.pageXOffset !== undefined;
	var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	var windowY = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
	var scrollThresholdClass = 'beyond-scroll-threshold';

	if ( windowY > 5 ) {
		document.body.classList.add(scrollThresholdClass);
	} else {
		document.body.classList.remove(scrollThresholdClass);
	}

};

/**
 *
 *
 *
 */
const getWindowWidth = function() {

	const win = window;
	const doc = document;
	const docElem = doc.documentElement;
	const body = doc.getElementsByTagName('body')[0];
	const x = win.innerWidth || docElem.clientWidth || body.clientWidth;

	return x;

};

/**
 *
 *
 *
 */
const isElementInViewport = ( el ) => {

	var rect = el.getBoundingClientRect();

	return (
		( rect.top <= 0 && rect.bottom >= 0 )
		||
		( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
		||
		( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
	);

};


const api = {
	init: init
};

export default api;